import { Flex } from 'antd';
import { ButtonAnt } from '@/components/buttons/button/ButtonAnt';
import { Form, Input } from '@/components/form';
import { FormattedMessage, useIntl } from '@/components/formatted_message/FormattedMessage';
import { useAuthContext } from '@/contexts/AuthContext';
import { commonMessages } from '@/routes/auth/messages';
import { AuthLayout } from '../../components/AuthLayout';
import { IDENTIFY_FORM_INITIAL_VALUES } from './constants';
import { Page as messages } from './messages';

interface IdentifyFormValues {
  email: string;
}

export const IdentifyPage = () => {
  const intl = useIntl();
  const [form] = Form.useForm<IdentifyFormValues>();
  const { identify, loading, resetMutation } = useAuthContext();

  const handleSubmit = ({ email }: IdentifyFormValues) => {
    identify({ identifier: email });
  };

  return (
    <AuthLayout>
      <Form
        form={form}
        initialValues={IDENTIFY_FORM_INITIAL_VALUES}
        layout="vertical"
        onChangeCapture={() => resetMutation.identify()}
        onFinish={handleSubmit}
      >
        <Flex gap={24} vertical>
          <Form.Item
            label={intl.formatMessage(messages.email)}
            name="email"
            rules={[
              {
                required: true,
                message: intl.formatMessage(commonMessages.emailRequired),
                validateTrigger: 'onSubmit',
              },
              {
                type: 'email',
                message: intl.formatMessage(commonMessages.emailNotValid),
                validateTrigger: 'onSubmit',
              },
            ]}
          >
            <Input
              autoFocus
              data-cy="identify-email"
              data-test="identify-email"
              placeholder={intl.formatMessage(messages.email)}
            />
          </Form.Item>
          <Form.Item>
            <ButtonAnt
              data-cy="identify-submit-button"
              data-test="identify-submit-button"
              htmlType="submit"
              loading={loading.isLoadingLogin}
              size="large"
              type="primary"
            >
              <FormattedMessage {...messages.continue} />
            </ButtonAnt>
          </Form.Item>
        </Flex>
      </Form>
    </AuthLayout>
  );
};
